import { useToastContext, ToastOptions } from '@contexts/ToastContext';
import { useCallback } from 'react';

// Native-base compatible useToast hook
export const useToast = () => {
  const { show, hide, hideAll } = useToastContext();

  // Native-base compatible show method
  const showToast = useCallback(
    (options: ToastOptions | string) => {
      // Handle both string and object parameters (native-base compatibility)
      if (typeof options === 'string') {
        return show({
          title: options,
          status: 'info',
        });
      }

      // Handle native-base style options
      const toastOptions: ToastOptions = {
        title: options.title,
        description: options.description,
        status: options.status || 'info',
        duration: options.duration,
        placement: options.placement,
        isClosable: options.isClosable,
        onCloseComplete: options.onCloseComplete,
        render: options.render,
      };

      return show(toastOptions);
    },
    [show],
  );

  // Native-base compatible close method
  const closeToast = useCallback(
    (id: string) => {
      hide(id);
    },
    [hide],
  );

  // Native-base compatible closeAll method
  const closeAllToasts = useCallback(() => {
    hideAll();
  }, [hideAll]);

  return {
    show: showToast,
    close: closeToast,
    closeAll: closeAllToasts,
    // Additional methods for compatibility
    hide: closeToast,
    hideAll: closeAllToasts,
  };
};
